var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import { useComponents } from '@tencent/dz-elements';
import { useMessageModel, useConsultModel } from '../../../hooks';
import styles from './style/index.less';
import { UIButton } from '@tencent/dz-bricks-ui';
import { useReportService } from './useReportService';
import { ReplyType } from '../../../const';
var SearchTerm = function (props) {
    var messageId = props.messageId;
    var _a = useComponents(), View = _a.View, Image = _a.Image;
    var messageModel = useMessageModel();
    var consultModel = useConsultModel();
    var query = consultModel.queryWord || '';
    var searchQuery = query === '' ? '' : "\u6211\u60F3\u54A8\u8BE2" + query;
    var config = useConsultModel().getConsultConfig();
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var preinput_enable = config.preinput_enable, preinput_type = config.preinput_type, enable_recommend_question = config.enable_recommend_question;
    var report = useReportService(query, config);
    useEffect(function () {
        if (preinput_enable === 1 && preinput_type === 2 && query !== '') {
            messageModel.updateInputMessage(searchQuery, true);
            messageModel.updateInputMessageSource(__assign(__assign({}, report.reportModuleParams), { payload: {
                    reply_type: ReplyType.search,
                    reply_content: searchQuery,
                } }));
        }
        ;
    }, []);
    var editTerm = function () {
        messageModel.updateInputMessage(searchQuery, true);
        messageModel.updateInputMessageSource(__assign(__assign({}, report.reportModuleParams), { payload: {
                reply_type: ReplyType.search,
                reply_content: searchQuery,
            } }));
        // 上报编辑行为
        report.searchTermEditClick(query);
        report.searchTermSendExposure(query);
        // 点击编辑后不展示预发送样式
        messageModel.deleteMessage(messageId);
    };
    var sendTerm = function () {
        messageModel.sendMessage(searchQuery);
        // 上报发送行为
        report.searchTermSendClick(query);
        // 点击发送后不展示预发送样式
        messageModel.deleteMessage(messageId);
    };
    return (React.createElement(React.Fragment, null, preinput_enable === 1 && preinput_type === 1 && enable_recommend_question === 2 && query !== '' && (React.createElement(View, { className: styles['customer-msg-wrapper'], id: "card_queryword_preinput" },
        React.createElement(View, { className: styles['customer-msg'] },
            React.createElement(View, { className: styles['send-state'] }, '未发送'),
            React.createElement(View, { className: styles['customer-msg-content'] },
                React.createElement(View, { className: styles['customer-msg-content-tail'] }),
                "\u6211\u8981\u54A8\u8BE2",
                query),
            React.createElement(Image, { className: styles['customer-msg-avatar'], src: "//leads.gdtimg.com/qzone/biz/gdt/fmc_consult/images/chart_user.svg", imageHeight: 37, imageWidth: 37 })),
        React.createElement(View, { className: styles['staff-option'] + " " + styles['server-answer'] },
            React.createElement(UIButton, { className: styles['staff-option-btn'] + " " + styles['staff-option-btn-edit'], onClick: editTerm }, "\u7F16\u8F91"),
            React.createElement(UIButton, { className: styles['staff-option-btn'] + " " + styles['staff-option-btn-send'], onClick: sendTerm }, "\u53D1\u9001"))))));
};
export default SearchTerm;
